import { useState } from "react"

// images
import snoozeImage from "@/assets/img/icons/snooze.svg"

// libraries
import { Menu } from "@mui/material"
import { useQueryClient } from "@tanstack/react-query"

// helpers
import Api from "@/_helpers/Api"
import { trans } from "@/_providers/Translation"

export default function SnoozeUpcomingTodoButton({ id }) {
  const queryClient = useQueryClient()

  const [openMenu, setOpenMenu] = useState(null)

  function handleCloseMenu() {
    setOpenMenu(null)
  }

  function handleOpenMenu(e) {
    setOpenMenu(e.currentTarget)
  }

  function handleSelectSnoozeOption(option) {
    Api.post(`todos/${id}/postpone`, { interval: option }).then((res) => {
      queryClient.invalidateQueries({ queryKey: ["todos/new"] })
      queryClient.invalidateQueries({ queryKey: ["todos/all"] })
    })

    handleCloseMenu()
  }

  return (
    <>
      <button className="button-default button-small" onClick={handleOpenMenu}>
        <img src={snoozeImage} alt="snooze" />
        {trans("buttons.postpone")}
      </button>

      <Menu
        anchorEl={openMenu}
        keepMounted
        open={Boolean(openMenu)}
        onClose={handleCloseMenu}
      >
        <div
          className="menu-option"
          onClick={() => handleSelectSnoozeOption("1_day")}
        >
          {trans("random.snooze1Day")}
        </div>
        <div
          className="menu-option"
          onClick={() => handleSelectSnoozeOption("2_days")}
        >
          {trans("random.snooze2Days")}
        </div>
        <div
          className="menu-option"
          onClick={() => handleSelectSnoozeOption("3_days")}
        >
          {trans("random.snooze3Days")}
        </div>
        <div
          className="menu-option"
          onClick={() => handleSelectSnoozeOption("1_week")}
        >
          {trans("random.snooze1Week")}
        </div>
      </Menu>
    </>
  )
}
